import { withTranslation } from "react-i18next"
import { CustomButton } from "components/Common"
import { exportUserList } from "helpers/app-backend"
const ImportExportButton = ({
    t, onExportUserList
}) => {
    return (
        <>
            <div className="tooltip-custom">
                <CustomButton
                    isEdit
                    color="secondary"
                    outline
                    onClick={() => { onExportUserList && onExportUserList() }}
                >
                    <i className={"fas fa-download"}></i>
                </CustomButton>
                <span className="tooltiptext-custom-button-icon-left">
                    {t("Export")}
                </span>
            </div>
        </>
    )
}
export default withTranslation(["userPage", "common"])(ImportExportButton)